import * as React from "react";
import withProjectVariables, { WithProjectVariablesExternalProps } from "../withProjectVariables";
import withValidateOnChange, { WithValidateOnChangeExternalProps } from "../withValidateOnChange";
import { ControlType } from "client/resources";
import { VariableType } from "client/resources/variableResource";
import { compose } from "recompose";
import VariableSelect, { VariableSelectRequiredProps, VariableSelectOptionalProps} from "components/form/VariableSelect";
import { withBoundField } from "components/form/BoundField/BoundField";

type AccountVariableSelectExternalProps = WithProjectVariablesExternalProps & WithValidateOnChangeExternalProps<string> & VariableSelectOptionalProps;
type AccountVariableSelectProps = VariableSelectRequiredProps & VariableSelectOptionalProps;

const enhance = compose<AccountVariableSelectProps, AccountVariableSelectExternalProps>(
    withProjectVariables({
        controlType: ControlType.AmazonWebServicesAccount,
        variableType: VariableType.AmazonWebServicesAccount
    }),
    withValidateOnChange()
);

const enhancedComponent = enhance(VariableSelect);

export default enhancedComponent;
export { VariableSelect, AccountVariableSelectProps, enhance };

export const BoundAccountVariableSelect = withBoundField(enhancedComponent);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/AccountSelect/AccountVariableSelect.tsx